// src/lib/sanity.ts
import { createClient } from '@sanity/client';
import config from './sanityConfig.json';

/**
 * Shared, read-only Sanity client for the public site.
 *
 * `useCdn: true` serves queries from Sanity's edge cache, which is what we want for
 * published content: lower latency and no load on the primary API. The cache is
 * invalidated when content is published, so editor changes still show up quickly.
 * If drafts or guaranteed read-after-write are ever needed, create a separate
 * uncached client rather than turning the CDN off for everything.
 *
 * The project id and dataset live in sanityConfig.json so the build-time scripts
 * (sitemap / prerender) read the same values.
 */
export const client = createClient({
  projectId: config.projectId,
  dataset: config.dataset,
  apiVersion: '2023-01-01',
  useCdn: true,
});

/**
 * Bypasses the CDN cache: always the live, current data, at the cost of a little latency and
 * more load on the primary API. For content that's actively being edited and re-checked right
 * away — right now, that's the gallery — where a stale answer (an old title still showing
 * after it was cleared and published) is worse than the extra delay.
 */
export const freshClient = client.withConfig({ useCdn: false });
